import { generateMedia } from 'styled-media-query'

const media = generateMedia({
  mobile: '46em',
  tablet: '60em',
  desktop: '78em',
})

export default media
